import { render } from "./AuthShell.vue?vue&type=template&id=9a29f48a"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9a29f48a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a29f48a', script)) {
    api.reload('9a29f48a', script)
  }
  
  module.hot.accept("./AuthShell.vue?vue&type=template&id=9a29f48a", () => {
    api.rerender('9a29f48a', render)
  })

}

script.__file = "src/views/auth/AuthShell.vue"

export default script